
namespace TabAurous.Sales {
    import fld = Sales.SalesItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class TopBrandsGrid extends _Ext.GridBase<Sales.SalesItemsRow, any> {
        protected getColumnsKey() { return 'Sales.TopBrands'; }
        protected getIdProperty() { return Sales.SalesItemsRow.idProperty; }
        protected getLocalTextPrefix() { return Sales.SalesItemsRow.localTextPrefix; }
        protected getService() { return Sales.TopBrandsService.baseUrl; }
        private chartContainer: JQuery;
        //private chartPanel: ProductWiseSalesPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("Top Brands");
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
        protected getColumns() {
            var columns = super.getColumns();

            var GrossAmount = Q.first(columns, x => x.field === fld.GrossAmount);
            GrossAmount.referencedFields = [fld.GrossAmount];
            GrossAmount.format = ctx => {
                var color;

                if (ctx.item.GrossAmountPercent < 30) {
                    color = "#9FF400";
                } else if (ctx.item.GrossAmountPercent < 70) {
                    color = "#E6E300";
                } else {
                    color = "#FFCD00";
                }
                return "<div class='progress-bar' role='progressbar' style='width: " + ctx.item.GrossAmountPercent + "%; color:black;text-align: center;' aria-valuenow='" + ctx.item.GrossAmount + "' aria-valuemin='0' aria-valuemax='100'>" + ctx.item.GrossAmount + "</div>";
                //return "<span class='percent-complete-bar' style='background:" + color + ";width:" + ctx.item.GrossAmountPercent + "%'>" + ctx.item.GrossAmount + "</span>";

            };
            return columns;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = false;
            return opt;
        }
        protected createQuickSearchInput() { }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();

            return []
        }
        protected usePager() { return false; }
    }

   
}